type PropsI = {
    text?: string;
}

const Loader = ({text = ""}:PropsI) => {
    return (
        <div style={{
            display: 'flex',
            width: '100%',
            height: '100vh',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            <div className="d-flex justify-content-center">
                <div className="spinner-border text-primary" role="status"
                style={{width: '4rem', height: '4rem'}}>
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
            <h4 className="mt-2">{text ? text : 'Cargando...'}</h4>
        </div>
    )
}

export default Loader
